import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { handleLoading } from "../appStore/actions/AppState/action";
import { useAbortController } from "./useAbortController";
import {
  getAllGroupAnalytics,
  getGroupRecipient,
  } from "../appStore/actions/ArkchatGroup/action";
import { getTopicListForSelectedGroupTaskApprTabs } from "../appStore/actions/topics/action";

export const useGroupTaskApprovalLogic = ({
  listApi,
  analyticsApi,
  filterConfig,
  currentUserData,
  setFilterActive,
  setSideBarOpen,
  setGroupActive,
  filterActive,
  groupActive,
  setSidebarLeft,
  sidebarLeft,
  setShowSidebar,
}) => {
  const dispatch = useDispatch();

  const cloneGroupList = useSelector(
    (state) => state?.arkchatgroup?.cloneGroupList,
  );

  const [selectedTabGroup, setSelectedTabGroup] = useState({});
  const [filterChecked, setFilterChecked] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [viewTabValue, setViewTabValue] = useState(1);
  const [tabValue, setTabValue] = useState(0);
  const [selectedMember, setSelectedMember] = useState([]);
  const [buttonDrawer, setButtonDrawer] = useState(null);
  const [selectedGroupTopic, setSelectedGroupTopic] = useState([]);
  const [groupTopicList, setGroupTopicList] = useState([]);
  const [recipientDetails, setRecipientDetails] = useState({
    internalMember: [],
    externalMember: [],
  });

  const topicAbort = useAbortController();
  const recipientAbort = useAbortController();

  useEffect(() => {
    dispatch(getAllGroupAnalytics()).then((res) => {
      if (res?.data?.length > 0) {
        const groupData = res?.data[0];
        handleSelectTabGroup(groupData);
      }
    });
  }, []);

  const handleSelectTabGroup = (groupData) => {
    setSelectedTabGroup(groupData);
    handelGetSelectGroupRecipient(groupData);
    handleGetSelectedGroupTopic(groupData);
  };

  const handelGetSelectGroupRecipient = (groupData) => {
    const signal = recipientAbort.getSignal();
    dispatch(getGroupRecipient(groupData?.id, signal)).then((data) => {
      const result = data?.reduce(
        (acc, item) => {
          if (item.inviteType === 2) {
            acc.external.push(item);
          } else {
            acc.internal.push(item);
          }
          return acc;
        },
        { internal: [], external: [] },
      );

      setRecipientDetails({
        ...recipientDetails,
        internalMember: result?.internal,
        externalMember: result?.external,
      });
    });
  };

  const handleGetSelectedGroupTopic = (groupData) => {
    const signal = topicAbort.getSignal();
    dispatch(
      getTopicListForSelectedGroupTaskApprTabs(
        { group_id: groupData.id },
        signal,
      ),
    ).then((data) => {
      setGroupTopicList(data?.data || []);
    });
  };

  const handleCheckedFilter = (event) => {
    const { name, value } = event.target;

    if (event.target.checked) {
      const selectedType = {
        type: name,
        value: value,
      };
      setFilterChecked([...filterChecked, selectedType]);
    } else {
      const checkedData = filterChecked?.filter(
        // eslint-disable-next-line eqeqeq
        (item) => item?.value != event.target.value,
      );
      setFilterChecked(checkedData);
    }
  };

  const handleClearFilter = (page = null, lastData = null) => {
    let finalQueryString;

    if (selectedMember?.length > 0) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&userId=${selectedMember[0]?.userId}`;
    } else if (tabValue === 0) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&userId=${currentUserData?.id}`;
    } else if (tabValue === 3) {
      finalQueryString = `groupId=${selectedTabGroup?.id}`;
    } else if (tabValue === 4) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&is_archived=true`;
    } else if (tabValue === 4) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&is_archived=true`;
    }
    dispatch(listApi(finalQueryString, page, lastData));
    setFilterChecked([]);
  };

  const handleApplyTaskFilter = (queryData, page = null, lastData = null) => {
    !page && dispatch(handleLoading(true));

    if (!queryData?.length) {
      handleClearFilter(page, lastData);
      return;
    }

    const params = new URLSearchParams();

    queryData.forEach((item) => {
      const config = filterConfig[item.value];
      if (!config) return;

      // Boolean filters
      if (config.type === "boolean") {
        params.set(item.value, true);
      }
      //custom key value
      if (config.type === "customValue") {
        params.set(config.customKey, config.value);
      }

      // Custom date range
      if (
        config.type === "date_range" &&
        selectedDateRange?.startDate &&
        selectedDateRange?.endDate
      ) {
        params.set(config.fromKey, selectedDateRange.startDate);
        params.set(config.toKey, selectedDateRange.endDate);
      }
    });

    const queryString = params.toString();
    let finalQueryString;

    if (selectedMember?.length > 0) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&userId=${selectedMember[0]?.userId}&${queryString}`;
    } else if (tabValue === 0) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&userId=${currentUserData?.id}&${queryString}`;
    } else if (tabValue === 3) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&${queryString}`;
    } else if (tabValue === 4) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&is_archived=true&${queryString}`;
    } else if (tabValue === 4) {
      finalQueryString = `groupId=${selectedTabGroup?.id}&is_archived=true&${queryString}`;
    }
    dispatch(listApi(finalQueryString, page, lastData));
  };

  const handleSelectMemberCheck = (event, item) => {
    if (!event.target.checked) {
      setSelectedMember([]);
    }
    if (event.target.checked) {
      setSelectedMember([item]);
      if (viewTabValue === 1) {
        dispatch(
          listApi(`groupId=${selectedTabGroup?.id}&userId=${item?.userId}`),
        );
      } else {
        dispatch(
          analyticsApi(
            `groupId=${selectedTabGroup?.id}&userId=${item?.userId}`,
          ),
        );
      }
    }

    handlecloseTeamlist();
  };

  const handleSelectGroupTopic = (topic) => {
    if (topic) {
      setSelectedGroupTopic([topic]);
      if (viewTabValue === 1) {
        dispatch(
          listApi(`groupId=${selectedTabGroup?.id}&topicId=${topic?.id}`),
        );
      } else {
        dispatch(
          analyticsApi(`groupId=${selectedTabGroup?.id}&topicId=${topic?.id}`),
        );
      }
    }

    handlecloseTopiclist();
  };
  const handleTabClick = (index) => {
    if ((index === 1 || index === 2) && tabValue === index) {
      handleChange("", index);
    }
  };

  const handleChange = (_, newValue) => {
    if (viewTabValue === 1) {
      dispatch(handleLoading(true));
      if (newValue === 0) {
        // Mine = 0
        dispatch(
          listApi(
            `groupId=${selectedTabGroup?.id}&userId=${currentUserData?.id}`,
          ),
        ).then(() => dispatch(handleLoading(false)));
      } else if (newValue === 1) {
        // Team = 1
        handleClicktabButton("Team");
      } else if (newValue === 2) {
        // Topic = 2
        handleClicktabButton("Topic");
      } else if (newValue === 3) {
        // All = 3
        dispatch(listApi(`groupId=${selectedTabGroup?.id}`)).then(() =>
          dispatch(handleLoading(false)),
        );
      } else if (newValue === 4) {
        // Archive = 4
        dispatch(
          listApi(`groupId=${selectedTabGroup?.id}&is_archived=true`),
        ).then(() => dispatch(handleLoading(false)));
      }

      setTabValue(newValue);
      setSelectedMember([]);
      setFilterChecked([]);
      return;
    }

    if (newValue === 0) {
      dispatch(analyticsApi(`userId=${currentUserData?.id}`));
    } else if (newValue === 1) {
      handleClicktabButton("Team");
      dispatch(analyticsApi());
    } else if (newValue === 2) {
      handleClicktabButton("Topic");
      dispatch(analyticsApi());
    } else if (newValue === 3) {
      dispatch(analyticsApi(`groupId=${selectedTabGroup?.id}`));
    } else if (newValue === 4) {
      dispatch(analyticsApi(`is_archived=true`));
    }

    setTabValue(newValue);
    setSelectedMember([]);
    setFilterChecked([]);
  };

  const handleSidebarClick = (type) => {
    if (type === "filter") {
      setFilterActive(!filterActive);
      setSideBarOpen(true);
    } else if (type === "group") {
      setGroupActive(!groupActive);
      setSideBarOpen(true);
    } else if (type === "sidebarleft") {
      setSidebarLeft(!sidebarLeft);
      if (!filterActive && !groupActive) {
        setFilterActive(!filterActive);
        setGroupActive(!groupActive);
      }
      setSideBarOpen(true);
    }
    makeFilterDeactive(type);
  };
  const handleClicktabButton = (name) => {
    setButtonDrawer({
      header: name,
      isOpen: true,
    });
  };

  const handlecloseTeamlist = (triggerFrom) => {
    if (triggerFrom === "closeButton") {
      handleChange("", 0);
    }
    setButtonDrawer({ ...buttonDrawer, isOpen: false });
  };

  const handlecloseTopiclist = (triggerFrom) => {
     if (triggerFrom === "closeButton") {
      handleChange("", 0);
    }
    setButtonDrawer({ ...buttonDrawer, isOpen: false });
  };

  const handleResetTab = () => {
    setTabValue(0);
    setSelectedMember();
    setSelectedMember([]);
  };
  const handleViewChange = (event, newValue) => {
    if (newValue === 0) {
      setShowSidebar(false);
    } else {
      setShowSidebar(true);
    }
    setTabValue(0);
    setViewTabValue(newValue);
    setSelectedMember([]);
    setFilterChecked([]);
  };

  const makeFilterDeactive = (type) => {
    if (type === "filter") {
      if (!groupActive && filterActive) {
        setSidebarLeft(false);
      }
    } else if (type === "group") {
      if (!filterActive && groupActive) {
        setSidebarLeft(false);
      }
    }
  };

  const handleAPiCall = () => {
    handleResetTab();
    if (selectedTabGroup?.id) {
      dispatch(handleLoading(true));
      dispatch(
        listApi(
          `groupId=${selectedTabGroup?.id}&userId=${currentUserData?.id}`,
        ),
      ).then(() => dispatch(handleLoading(false)));
      dispatch(
        analyticsApi(
          `groupId=${selectedTabGroup?.id}&userId=${currentUserData?.id}`,
        ),
      );
    }
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    handleAPiCall();
  }, [selectedTabGroup]);

  return {
    selectedTabGroup,
    setSelectedTabGroup,
    buttonDrawer,
    setButtonDrawer,
    selectedGroupTopic,
    setSelectedGroupTopic,
    groupTopicList,
    setGroupTopicList,
    recipientDetails,
    setRecipientDetails,
    filterChecked,
    setFilterChecked,
    tabValue,
    setTabValue,
    viewTabValue,
    setViewTabValue,
    selectedMember,
    setSelectedMember,
    selectedDateRange,
    setSelectedDateRange,

    handleSelectTabGroup,
    handelGetSelectGroupRecipient,
    handleGetSelectedGroupTopic,
    handleCheckedFilter,
    handleClearFilter,
    handleApplyTaskFilter,
    handleSelectMemberCheck,
    handleSelectGroupTopic,
    handleTabClick,
    handleChange,
    handleSidebarClick,
    handleClicktabButton,
    handlecloseTeamlist,
    handlecloseTopiclist,
    handleResetTab,
    handleViewChange,
  };
};
